import * as React from "react";
import { cn } from "@/lib/utils";

// Friendly empty state — icon in a tinted circle, title, description, optional action.
function EmptyState({ className, icon: Icon, title, description, action, ...props }) {
  return (
    <div
      data-kit=""
      className={cn("flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card px-6 py-14 text-center", className)}
      {...props}
    >
      {Icon ? (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-tint text-primary [&>svg]:size-7">
          <Icon />
        </div>
      ) : null}
      {title && <h3 className="text-base font-bold text-foreground">{title}</h3>}
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export { EmptyState };
